module.exports = __webpack_public_path__ + "static/media/zillow.89a32874.png";